<template>
	<div class="ng-scope show-sticky-calc">
		<headerNavigation @openLoginMadal="openLoginMadal" @changeRegister="changeRegister"></headerNavigation>
		<template v-if="isMobile">
			<div class="div-after-fixed-header" style="height: 115px;"></div>
		</template>
		<div class="site-main-container">
			<div class="page-custom-quote-container">
				<div class="quote-banner container">
					<div class="row">
						<div class="col-sm-12 banner-content-container">
							<div class="comp-breadcrumbs-container">
								<ol class="breadcrumbs-list">
									<li class="breadcrumb-list-item">
										<a href="javascript:void()" @click="openPage('/')">{{$t('common.home')}}</a>
									</li>
									<li class="breadcrumb-list-item">{{$t('common.customquote')}}</li>
								</ol>
							</div>
							<div style="width: 100%;overflow: hidden;">
								<h1 class="custom-quote-heading">{{$t('customerTrust.customprintingquote')}}</h1>
								<span class="rating">
									<img src="../../assets/images/star.png" class="star-icon" v-for="item in 5"/>
								</span>
							</div>
							<h5 class="banner-slogan"><strong>{{$t('customerTrust.thinkitprintit')}}</strong></h5>
							<p>{{$t('customerTrust.customprintingquotetxt')}}</p>
						</div>
						<div class="col-sm-12 hidden-xs">
							<div class="banner-img">
								<img src="../../assets/images/quote-img-min.jpg"/>
							</div>
						</div>
					</div>
				</div>
				<div class="form-container">
					<div class="quote-form-wrapper">
						<div class="container">
							<div class="quote-form ng-untouched ng-pristine ng-invalid">
								<div class="row">
									<div class="col-xs-12 product-type-container">
										<div class="form-panel product-type-panel">
											<h3 class="header">1. {{$t('common.customerinformation')}}</h3>
											<div class="form-wrapper product-specs-form-wrapper">
												<div class="row">
													<div class="col-xs-12">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">*{{$t('login.name')}}：</span>
															</div>
															<div class="site-input-group">
																<input v-model="appellation" class="site-form-input form-control ng-untouched ng-pristine ng-invalid"/>
															</div>
														</div>
													</div>
													<div class="col-xs-12">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">{{$t('login.companyname')}}：</span>
															</div>
															<div class="site-input-group">
																<input v-model="companyName" class="site-form-input form-control ng-untouched ng-pristine ng-invalid"/>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-12">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">*{{$t('login.email')}}：</span>
															</div>
															<div class="site-input-group">
																<input v-model="email" class="site-form-input form-control ng-untouched ng-pristine ng-invalid"/>
															</div>
														</div>
													</div>
													<div class="col-xs-12">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">{{$t('address.phone')}}：</span>
															</div>
															<div class="site-input-group">
																<input v-model="mobile" class="site-form-input form-control ng-untouched ng-pristine ng-invalid"/>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-xs-12 product-type-container">
										<div class="form-panel product-type-panel">
											<h3 class="header">2. {{$t('common.standardoptions')}}</h3>
											<div class="form-wrapper product-specs-form-wrapper">
												<div class="row">
													<div class="col-xs-12">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">{{$t('common.productname')}}：</span>
															</div>
															<div class="site-input-group">
																<input v-model="productName" class="site-form-input form-control ng-untouched ng-pristine ng-invalid"/>
															</div>
														</div>
													</div>
													<div class="col-xs-12">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">{{$t('common.quantity')}}：</span>
															</div>
															<div class="site-input-group">
																<input v-model="qty" class="site-form-input form-control ng-untouched ng-pristine ng-invalid"/>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-12">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">{{$t('common.material')}}：</span>
															</div>
															<div class="site-input-group">
																<input v-model="material" class="site-form-input form-control ng-untouched ng-pristine ng-invalid"/>
															</div>
														</div>
													</div>
													<div class="col-xs-12">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">{{$t('common.postprocessing')}}：</span>
															</div>
															<div class="site-input-group">
																<input v-model="processing" class="site-form-input form-control ng-untouched ng-pristine ng-invalid"/>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-xs-12">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">{{$t('common.daterequirement')}}：</span>
															</div>
															<div class="site-input-group">
																<input v-model="daterequirements" type="date" class="site-form-input form-control ng-untouched ng-pristine ng-invalid"/>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="site-form-group form-group">
														<div class="input-label-container">
															<span class="site-input-label">{{$t('common.uploadfiles')}}（{{$t('common.maximumMB')}}）</span>
														</div>
														<div class="site-upload-inner">
															<div class="upload-img-block" v-if="imgList.length > 0" v-for="(item,index) in imgList" :key="index">
																<img :src="item" class="u-img"/>
																<div class="del-block" @click="delDesign(index)">
																	<img src="../../assets/images/close-white.png" class="del-icon"/>
																</div>
															</div>
															<div class="upload-block">
																<input type="file" class="upload-input-s" accept="image/*" @change="onFileChange"/>
																<img src="../../assets/images/upload.png" class="upload-icon"/>
																<div class="upload-txt">{{$t('common.uploadfiles')}}</div>
															</div>
														</div>
													</div>
												</div>
												<div class="additional-instructions-container">
													<div class="site-form-group form-group">
														<div class="input-label-container">
															<span class="site-input-label">*{{$t('common.additionalremark')}}</span>
														</div>
														<div class="site-input-group">
															<textarea v-model="content" class="site-form-input form-control ng-untouched ng-pristine ng-valid"></textarea>
														</div>
													</div>
													<div class="submit-quote-wrapper">
														<button class="custom-quote-btn" @click="doConfirm">{{$t('common.submitquote')}}</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
		<loading v-if="isLoading"></loading>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
		import footers from '../../components/footers.vue'
		import loginModal from '../../components/loginModal.vue'
		import loading from '../../components/loading.vue'
		import {uploadFile,confirmQuotes} from '../../api/api.js'
		export default {
			components: {
				headerNavigation,
				footers,
				loginModal,
				loading
			},
			data() {
				return {
					isMobile: false,
					showLoginModal: false,
					isLoading:false,
					email:'',
					appellation:'',
					companyName:'',
					productName:'',
					qty:'',
					material:'',
					processing:'',
					daterequirements:'',
					content:'',
					imgList:[],
					mobile:'',
					selectedFile:null
				};
			},
			created() {
				this.isMobile = this.webIsMobile()
			},
			methods: {
				openLoginMadal() {
					this.showLoginModal = true
					this.changeRegister(false)
				},
				closeLoinMadal() {
					this.showLoginModal = false
				},
				changeRegister(e) {
					this.$refs.loginRef.changeRegisterType(e)
					this.showLoginModal = true
				},
				onFileChange(e) {
				    this.selectedFile = e.target.files[0];
					this.uploadImage()
				},
				uploadImage() {
				    const formData = new FormData();
				    formData.append('file', this.selectedFile, this.selectedFile.name);
				    var that = this;
					
				    let params = formData
					this.isLoading = true
				    uploadFile(params).then(res => {
						that.isLoading = false
				    	if (res.code == 200) {
				    		that.imgList.push(res.data.url)
				    	}else{
							that.$message.error(res.msg);
						}
				    })
				},
				delDesign(index){
					this.imgList.splice(index, 1);
				},
				verification() {
					if(!this.appellation){
						this.$message.warning(this.$t('tips.pleaseinputname'));
						return false;
					}
					if(!this.email){
						this.$message.warning(this.$t('tips.pleaseinputemail'));
						return false;
					}
					if(!this.content){
						this.$message.warning(this.$t('tips.pleaseinputcontent'));
						return false;
					}
					return true;
				},
				doConfirm(){
					if(this.verification()){
						var that = this;
						var designImg = ''
						if(this.imgList.length > 0){
							this.imgList.forEach(item => {
								designImg = designImg + item + ',';
							});
							if(designImg){
								designImg = designImg.substring(0, designImg.length - 1);
							}
						}
						let params = {
							email:this.email,
							appellation:this.appellation,
							companyName:this.companyName,
							productName:this.productName,
							qty:this.qty,
							material:this.material,
							processing:this.processing,
							daterequirements:this.daterequirements,
							content:this.content,
							mobile:this.mobile,
							fileurl:designImg
						}
						that.isLoading = true
						confirmQuotes(params).then(res => {
							that.isLoading = false
							if (res.code == 200) {
								that.$message.success(res.msg);
								setTimeout(() => {
								    that.openPage('/')
								}, 2000);
							}else{
								that.$message.warning(res.msg);
								return false;
							}
							
						})
					}
				}
			}
		}
</script>

<style scoped>
	@import url("../../assets/css/quotes.css");
	.global-header-spacer {
	    height: 60px !important;
	    display: block !important;
	}
</style>